export const fmt = (n, fxRate = 1, currSymbol = '$') => {
  if (n == null) return '\u2014';
  const converted = Math.round(fxRate !== 1 ? n / fxRate : n);
  const abs = Math.abs(converted);
  const str = abs >= 1000 ? abs.toLocaleString('en-CA', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : abs.toString();
  return converted < 0 ? `${currSymbol}(${str})` : `${currSymbol}${str}`;
};

export const fmtPct = (n) => {
  if (n == null || !isFinite(n)) return '\u2014';
  return `${n > 0 ? '+' : ''}${n.toFixed(1)}%`;
};

export const fmtCompact = (n, fxRate = 1, currSymbol = '$') => {
  const converted = fxRate !== 1 ? n / fxRate : n;
  const abs = Math.abs(converted);
  let str;
  if (abs >= 1000000) str = `${currSymbol}${(abs / 1000000).toFixed(1)}M`;
  else if (abs >= 1000) str = `${currSymbol}${(abs / 1000).toFixed(0)}K`;
  else str = `${currSymbol}${Math.round(abs)}`;
  return converted < 0 ? `(${str})` : str;
};

// Convenience wrapper using currency context values
// Just converts the number — no prefix change (the toggle makes it obvious)
export const fmtC = (n, ctx) => {
  if (!ctx || ctx.currency === 'CAD') return fmt(n);
  return fmt(n, ctx.fxRate, '$');
};

export const fmtCompactC = (n, ctx) => {
  if (!ctx || ctx.currency === 'CAD') return fmtCompact(n);
  return fmtCompact(n, ctx.fxRate, '$');
};

export const getDeadlineStatus = (dueDateStr, done, mockToday) => {
  if (done) return 'done';
  const now = mockToday ? new Date(mockToday) : new Date();
  const due = new Date(dueDateStr + 'T23:59:59');
  const hoursLeft = (due - now) / (1000 * 60 * 60);
  if (hoursLeft < 0) return 'overdue';
  if (hoursLeft < 48) return 'due-soon';
  return 'on-time';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '\u2014';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
};

export const formatTimestamp = (ts) => {
  if (!ts) return null;
  const d = new Date(ts);
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};
